<template>
  <v-container fluid class="vendor-dashboard pa-0">
    <v-row dense>
      <v-col cols="12" md="4">
        <v-card outlined class="vendor-note-card">
          <v-card-text class="pa-4">
            <div class="note-header">
              <div>
                <div class="section-title">Vendor Note</div>
                <div class="section-subtitle">
                  Save internal notes and alert status.
                </div>
              </div>

              <v-btn
                v-if="checkRightStatus(36)"
                small
                rounded
                color="primary"
                dark
                :loading="saving"
                @click="updateNote"
              >
                <v-icon left small>mdi-content-save-outline</v-icon>
                Save
              </v-btn>
            </div>

            <div
              v-if="checkRightStatus(37)"
              class="alert-box mt-4"
            >
              <div>
                <div class="alert-title">Vendor Alert</div>
                <div class="alert-subtitle">
                  Mark this vendor for attention.
                </div>
              </div>

              <toggle-button
                v-if="getVendor"
                @change="updateAlert"
                :labels="true"
                color="red"
                v-model="getVendor.alert"
                :value="getVendor.alert"
                :sync="true"
              />
            </div>

            <div class="field-label mt-4">Note</div>
            <v-textarea
              v-model="note"
              outlined
              dense
              auto-grow
              rows="6"
              hide-details
              label="Vendor Note"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8">
        <v-card outlined class="vendor-comment-card">
          <v-card-text class="pa-4">
            <div class="comment-header mb-4">
              <div>
                <div class="section-title">Comments</div>
                <div class="section-subtitle">
                  Vendor activity notes and communication history.
                </div>
              </div>
            </div>

            <Comment
              v-if="getVendor"
              :RelationId="getVendor"
              :TypeId="2"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import vendorService from "../service";
import Comment from "@/modules/Comment/components/List";

export default {
  name: "vendor-dashboard",

  components: {
    Comment,
  },

  data() {
    return {
      note: null,
      saving: false,
    };
  },

  computed: {
    ...mapGetters("vendor", ["getVendor"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },

  watch: {
    getVendor: {
      immediate: true,
      handler(val) {
        this.note = val && val.note ? val.note : null;
      },
    },
  },

  methods: {
    ...mapActions("vendor", ["setVendor"]),

    updateNote() {
      this.updateVendor({
        note: this.note,
      });
    },

    updateAlert(val) {
      this.updateVendor({
        alert: val.value,
      });
    },

    updateVendor(data) {
      if (!this.getVendor || !this.getVendor.id) {
        return false;
      }

      this.saving = true;

      return vendorService
        .update(this.getVendor.id, data)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Updated successfully",
            });

          this.setVendor(this.getVendor.id);
        })
        .catch((error) => {
          const message =
            error && error.data && error.data.message
              ? error.data.message
              : "Unable to update vendor";

          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: message,
            });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.vendor-dashboard {
  background: #f8fafc;
}

.vendor-note-card,
.vendor-comment-card {
  border-radius: 20px;
  background: #ffffff;
}

.note-header,
.comment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.section-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.section-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.alert-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.alert-title {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.alert-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.field-label {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 6px;
}

@media (max-width: 600px) {
  .alert-box {
    align-items: flex-start;
  }
}
</style>
